














































































import { Component, Prop, Vue } from "vue-property-decorator";
import EstimateService from "@/usecases/orders/estimate-service";
import PurchaseOption from "../components/PurchaseOption.vue";
import Purchase from "../../../usecases/orders/purchase";
import EstimatePurchase from "../presenters/estimate-purchase";
import EstimatePurchaseItem from "../presenters/estimate-purchase-item";
import PurchaseOptionHeader from "../components/PurchaseOptionHeader.vue";
import VToolbar from "../../common/components/VToolbar.vue";
import EstimateItem from "../../../usecases/orders/estimate-item";
import PurchaseItem from "../../../usecases/orders/purchase-item";
import EstimateApi from "../../../api/orders/estimate-api";
import { client } from "@/api/request";
import PurchaseApi from "../../../api/orders/purchase-api";
import formatDate from "../../../helpers/formatDate";
import { CONSUMPTION_TAX_RATE, ESTIMATE_ITEM_LEVEL } from "@/preferences";
import Decimal from "decimal.js";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import SelectOption from "@/common/ui/presenters/select-option";
import { Company, getVendorsForPurchase } from "@/api/company-api";
import Estimate from "@/usecases/orders/estimate";

const estimateApi = new EstimateApi(client);
const purchaseApi = new PurchaseApi(client);

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    VToolbar,
    PurchaseOptionHeader,
    PurchaseOption
  }
})
export default class NewPurchasePage extends Vue {
  @Prop({ required: true }) estimateId!: string;
  @Prop({ required: true }) idsRowSelected!: string;

  estimate = new EstimatePurchase();
  items: EstimatePurchaseItem[] = [];
  expenseCategories: ExpenseCategory[] = [];
  vendorOptions: SelectOption[] = [];
  vendorSelected: number = -1;
  isCheckAllRow: boolean = false;
  estimateRowSelected: Set<string> = new Set();
  estimateLoss: number = 0;
  estimateDiscount: number = 0;

  get selectedItems() {
    return selectedItems(this.items);
  }

  protected async created() {
    await this.initExpenseCategories();
    await this.initEstimateRowSelected();
    await this.initEstimate();
    await this.initVendorList();
  }

  private async initExpenseCategories() {
    this.expenseCategories = [
      {
        id: "",
        name: "",
        important: false,
        expense_category_invoice_flg: false
      },
      ...(await getExpenseCategories())
    ];
  }

  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }

  private async initVendorList() {
    const vendors = await getVendorsForPurchase(this.estimate.projectId);
    this.vendorOptions = vendors.map((v: Company) => ({
      text: v.name,
      value: String(v.office.officeId)
    }));
  }

  goPreviousPage() {
    this.$router.push({
      name: "order-estimate-edit",
      params: {
        id: this.estimateId
      }
    });
  }
  goListPage() {
    this.$router.push({ name: "order-purchase" });
  }

  private async initEstimate() {
    const estimateService = new EstimateService(estimateApi);
    let estimate = await estimateService.find(Number(this.estimateId));
    this.estimateLoss = estimate.loss;
    this.estimateDiscount = estimate.discount;
    estimate = this.filterEstimateRowSelected(estimate);
    estimate = await estimateService.calculateTotal(estimate);
    this.estimate = new EstimatePurchase(estimate);
    this.items = this.estimate.items.map(
      item => new EstimatePurchaseItem(item)
    );
  }

  async purchase() {
    const estimate = {
      ...this.estimate,
      items: purchasingItems(this.selectedItems)
    };
    const estimateSubtotal = estimate.items
      .map(i => new Decimal(i.totalPrice))
      .reduce((sum, p) => sum.plus(p))
      .floor();
    const loss = estimate.items
      .map(i => new Decimal(i.loss))
      .reduce((sum, p) => sum.plus(p))
      .floor();
    const tax = loss.times(new Decimal(CONSUMPTION_TAX_RATE).div(100)).floor();
    const lossTotal = loss.plus(tax);
    const discount =
      this.estimateLoss === 0
        ? 0
        : Math.ceil(
            new Decimal(loss)
              .div(this.estimateLoss)
              .times(this.estimateDiscount)
              .toNumber()
          );
    const estimateSubtotalDiscounted = estimateSubtotal.plus(discount);
    const estimateTax = estimateSubtotalDiscounted
      .times(new Decimal(estimate.taxRate).div(100))
      .floor();
    const estimateTotal = estimateSubtotalDiscounted.plus(estimateTax);
    let purchase = new Purchase();
    purchase = {
      ...purchase,
      title: estimate.title,
      projectId: estimate.projectId,
      projectName: estimate.projectName,
      estimateId: estimate.estimateId,
      estimateNumber: estimate.estimateNumber,
      estimateTotal: estimateTotal.toNumber(),
      estimateSubtotal: estimateSubtotal.toNumber(),
      estimateTax: estimateTax.toNumber(),
      estimateTaxRate: estimate.taxRate,
      estimateLoss: this.estimateLoss,
      estimateDiscount: this.estimateDiscount,
      vendorId: this.vendorSelected,
      loss: loss.toNumber(),
      lossTotal: lossTotal.toNumber(),
      tax: tax.toNumber(),
      taxRate: CONSUMPTION_TAX_RATE,
      items: estimate.items.map(it => this.purchaseItem(it)),
      issuedAt: formatDate(new Date()),
      dateOfIssue: formatDate(new Date())
    };
    try {
      await purchaseApi.save(purchase);
      await this.initEstimate();
      alert("保存しました。");
    } catch (error) {
      alert("保存に失敗しました。");
    }
  }

  private purchaseItem(item: EstimateItem): PurchaseItem {
    return {
      ...item,
      id: "",
      estimateItemId: item.id,
      invalid: false,
      items: item.items.map(it => this.purchaseItem(it))
    };
  }

  private async initEstimateRowSelected() {
    this.estimateRowSelected = new Set<string>(this.idsRowSelected.split(","));
  }

  private checkAllRow(isChecked: boolean) {
    this.items.forEach(item => (item.selected = isChecked));
  }

  private filterEstimateRowSelected(estimate: Estimate): Estimate {
    estimate.items = this.filterItems(estimate.items);
    if (estimate.children.length > 0) {
      estimate.children = estimate.children.map(child =>
        this.filterEstimateRowSelected(child)
      );
    }
    return estimate;
  }

  private filterItems(items: EstimateItem[]): EstimateItem[] {
    return items
      .filter(item => this.estimateRowSelected.has(item.id.toString()))
      .map(item => {
        if (item.items.length > 0) {
          item.items = this.filterItems(item.items);
        }
        return item;
      });
  }

  get disabledCreatePurchase(): boolean {
    const isUnselectVendor = this.vendorSelected === -1;
    let isUnselectItems = !(this.selectedItems.length > 0);
    return isUnselectItems || isUnselectVendor;
  }

  private countSelectedItems(items: EstimatePurchaseItem[]): number {
    return items.reduce((count, item) => {
      if (item.selected && !item.purchasedRow) count++;
      if (item.items) count += this.countSelectedItems(item.items);
      return count;
    }, 0);
  }

  private countTotalItems(items: EstimatePurchaseItem[]): number {
    return items.reduce((count, item) => {
      if (!item.purchasedRow) count++;
      if (item.items) count += this.countTotalItems(item.items);
      return count;
    }, 0);
  }

  private afterCheckboxChange() {
    let countItemsSelected = this.countSelectedItems(this.items);
    let numberItems = this.countTotalItems(this.estimate.items);
    this.isCheckAllRow = countItemsSelected === numberItems;
  }
}

function selectedItems(items: EstimatePurchaseItem[]): EstimatePurchaseItem[] {
  return items
    .filter(i => i.selected && !i.isPurchasedRow())
    .map(
      i => new EstimatePurchaseItem({ ...i, items: selectedItems(i.items) })
    );
}

function purchasingItems(
  items: EstimatePurchaseItem[]
): EstimatePurchaseItem[] {
  return items.map(item => {
    const children = purchasingItems(item.items);
    let unitPrice = 0;
    let totalPrice: number;
    if (item.items.length > 0) {
      totalPrice = children.reduce((sum, item) => sum + item.totalPrice, 0);
      if (item.amount > 0) {
        unitPrice = new Decimal(totalPrice)
          .div(item.amount)
          .floor()
          .toNumber();
      }
    } else {
      unitPrice = item.unitPrice;
      totalPrice = unitPrice * item.amount;
    }

    let unitLoss = 0;
    let loss: number;
    if (item.items.length > 0) {
      loss = children.reduce((sum, item) => sum + item.loss, 0);
      if (item.amount > 0) {
        unitLoss = new Decimal(loss)
          .div(item.amount)
          .floor()
          .toNumber();
      }
    } else {
      unitLoss = item.unitLoss;
      loss = unitLoss * item.amount;
    }

    return new EstimatePurchaseItem({
      ...item,
      items: children,
      unitPrice,
      totalPrice,
      unitLoss,
      loss
    });
  });
}
